import { MantineProvider } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import { useState } from "react"
import { BrowserRouter } from "react-router-dom"
import Authenticated from "../Authenticated"
import { AuthenticationProvider } from "../AuthenticationContext"
import Unauthenticated from "../Unauthenticated"
import { Color } from "./App.types"

const App = () => {
  const [token, setToken] = useState<string>(
    localStorage.getItem("token") ?? ""
  )

  const mobile = useMediaQuery("(max-width: 992px)")

  return (
    <AuthenticationProvider
      value={[
        token,
        (token: string) => {
          setToken(token)
          localStorage.setItem("token", token)
        },
      ]}
    >
      <MantineProvider
        theme={{
          colors: {
            backgroundColor: new Array(10).fill("white") as Color,
            unselectedColor: new Array(10).fill("black") as Color,
            selectedColor: new Array(10).fill("black") as Color,
          },
          primaryColor: "selectedColor",
        }}
      >
        <BrowserRouter>
          {token ? (
            <Authenticated mobile={mobile} />
          ) : (
            <Unauthenticated mobile={mobile} />
          )}
        </BrowserRouter>
      </MantineProvider>
    </AuthenticationProvider>
  )
}

export default App
